{
  "Assessment": "0xcafeaa5f9c401b7295890f309168Bbb8173690A3",
  "AssessmentViewer": "0xcafeaB457b2987Ec85a4db7b92a6C7D57C9e2b26",
  "cbBTC": "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
  "Chainlink-DAI-ETH": "0x773616E4d11A78F511299002da57A0a94577F1f4",
  "Chainlink-ENZYME-VAULT": "0xCc72039A141c6e34a779eF93AEF5eB4C82A893c7",
  "Chainlink-ETH-USD": "0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419",
  "Chainlink-RETH-ETH": "0x536218f9E9Eb48863970252233c8F271f554C2d0",
  "Chainlink-STETH-ETH": "0x86392dC19c0b719886221c78AB11eb8Cf5c52812",
  "Chainlink-CBBTC-USD": "0x2665701293fCbEB223D11A08D826563EDcCE423A",
  "Cover": "0xcafeac0fF5dA0A2777d915531bfA6B29d282Ee62",
  "CoverBroker": "0x0000cbD7a26f72Ff222bf5f136901D224b08BE4E",
  "CoverNFT": "0xcafeaCa76be547F14D0220482667B42D8E7Bc3eb",
  "CoverProducts": "0xcafead81a2c2508e7344155eB0DA67a3a487AA8d",
  "CoverViewer": "0xcafea84e199C85E44F34CD75374188D33FB94B4b",
  "DAI": "0x6B175474E89094C44Da98b954EedeAC495271d0F",
  "Governance": "0x4A5C681dDC32acC6ccA51ac17e9d461e6be87900",
  "IndividualClaims": "0xcafeac12feE6b65A710fA9299A98D65B4fdE7a62",
  "LegacyClaimProofs": "0xcafea81b73daB8F42C5eca7d2E821A82660B6775",
  "LegacyClaimsData": "0xdc2D359F59F6a26162972c3Bd0cFBfd8C9Ef43af",
  "LegacyClaimsReward": "0xcafeaDcAcAA2CD81b3c54833D6896596d218BFaB",
  "LegacyPooledStaking": "0x84EdfFA16bb0b9Ab1163abb0a13Ff0744c11272f",
  "LegacyQuotationData": "0x1776651F58a17a50098d31ba3C3cD259C1903f7A",
  "MCR": "0xcafea92739e411a4D95bbc2275CA61dE6993C9a7",
  "MemberRoles": "0x055CC48f7968FD8640EF140610dd4038e1b03926",
  "NXMToken": "0xd7c49CEE7E9188cCa6AD8FF264C1DA2e69D4Cf3B",
  "NXMaster": "0x01BFd82675DBCc7762C84019cA518e701C0cD07e",
  "NexusViewer": "0xcafea898587Beaf0FFf27A04915e4b3184462Cd0",
  "Pool": "0xcafeaf6eA90CB931ae43a8Cf4B25a73a24cF6158",
  "PriceFeedOracle": "0xcafea905B417AC7778843aaE1A0b3848CA97a592",
  "ProposalCategory": "0x888eA6Ab349c854936b98586CE6a17E98BF254b2",
  "Ramm": "0xcafea54f03E1Cc036653444e581A10a43B2487CD",
  "SafeTracker": "0xcafeaB8B01C74c2239eA9b2B0F6aB2dD409c6c13",
  "StakingNFT": "0xcafea508a477D94c502c253A58239fb8F948e97f",
  "StakingPoolFactory": "0xcafeafb97BF8831D95C0FC659b8eB3946B101CB3",
  "StakingProducts": "0xcafea573fBd815B5f59e8049E71E554bde3477E4",
  "StakingViewer": "0xcafea5E8a7a54dd14Bb225b66C7a016dfd7F236b",
  "SwapOperator": "0xcafeaed98d7Fce8F355C03c9F3507B90a974f37e",
  "TokenController": "0x5407381b6c251cFd498ccD4A1d877739CB7960B8",
  "USDC": "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
  "wNXM": "0x0d438F3b5175Bebc262bF23753C1E53d03432bDE"
}
